export default {
    "回复": "回复",
}



// WEBPACK FOOTER //
// ./src/languages/cn/detail.js